import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import distributionApi from 'services/api/distribution';
import { selectRelease } from 'services/store/distribution/selectors';

const useGetRelease = (releaseId: string) => {
  const [getRelease, { error, isLoading }] =
    distributionApi.useGetReleaseMutation();

  const release = useSelector(selectRelease(releaseId));

  const currentRelease = useMemo(() => {
    if (release) {
      return release;
    }

    return null;
  }, [release]);

  useEffect(() => {
    if (currentRelease || isLoading || error) {
      return;
    }
    getRelease({ releaseId });
  }, [releaseId, currentRelease, isLoading, error, getRelease]);

  return {
    currentRelease,
  };
};

export default useGetRelease;
